export default {
  setQuizzes (state, quizzes) {
    state.quizzes = quizzes
  },

  setQuiz (state, quiz) {
    state.quiz = quiz
  },

  setBackQuiz (state, quiz) {
    state.backQuiz = quiz
  },

  setNextQuiz (state, quiz) {
    state.nextQuiz = quiz
  },

  setNumber (state, number) {
    state.number = number
  },

  setCardNumber (state, cardNumber) {
    state.cardNumber = cardNumber
  },

  setSuit (state, suit) {
    state.suit = suit
  },

  setUrl (state, url) {
    state.url = url
  },

  setName (state, name) {
    state.name = name
  },

  setDescription (state, description) {
    state.description = description
  },

  setHint (state, hint) {
    state.hint = hint
  },

  setLat (state, lat) {
    state.lat = Number(lat)
  },

  setLng (state, lng) {
    state.lng = Number(lng)
  },

  setRadius (state, radius) {
    state.radius = radius
  }
}
